/* global process */

const alwaysSendToDefaultTracker = true;

interface FieldObject {
    eventCategory: string;
    eventAction: string;
    eventName?: string;
    eventLabel?: string;

    [key: string]: any;
}

interface FieldObjectPageView {
    event: string;
    page: string;
}

type TrackerNames = string[];

interface EventArgs {
    eventName?: string;
    category: string;
    action: string;
    label?: string;

    [key: string]: any;
}

interface AnalyticsDetails extends EventArgs {
    visitorType: string;
    visitorLoginState: 'no' | 'yes';
    pageLocale: string;
    user_id?: string;
}

async function encryptString(message) {
    try {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        return hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    } catch (error) {
        console.error(error);
    }
}

export function event(
    {eventName, category, action, label, ...args}: EventArgs | AnalyticsDetails,
    trackerNames?: TrackerNames
) {
    if (typeof window === 'undefined') {
        return;
    }

    if (!category || !action) {
        return;
    }

    // Check if analytics_storage consent is granted
    const consentSettings = JSON.parse(localStorage.getItem('cookieConsent'));
    if (!consentSettings || consentSettings.analytics_storage !== 'granted') {
        return;
    }

    // Required fields
    const fieldObject: FieldObject = {
        eventCategory: category,
        eventAction: action,
    };

    // Optional fields
    if (eventName) {
        fieldObject.eventName = eventName;
    }
    if (label) {
        fieldObject.eventLabel = label;
    }

    // Other fields
    Object.keys(args).forEach((key) => {
        fieldObject[key] = args[key];
    });
    // Send to Analytics
    send(fieldObject, trackerNames);
}

const internalGa = (...args) => {
    const cmd = args[0];
    const data = args[1];
    const {eventName, eventCategory, eventAction, eventLabel, ...rest} = data;

    if (cmd === 'send') {
        if (data.event && data.event === '_virtualPageView') {
            window.dataLayer.push({
                event: data.event,
                page: data.page,
            });
        } else {
            window.dataLayer.push({
                event: eventName,
                Category: eventCategory,
                Action: eventAction,
                Label: eventLabel,
                ...rest,
            });
        }
    }
};

function trackCommand(trackerNames, ...args) {
    if (alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) {
        internalGa(...args);
    }
}

export function send(fieldObject: FieldObject | FieldObjectPageView, trackerNames?: TrackerNames) {
    trackCommand(trackerNames, 'send', fieldObject);
}

export async function prepareAnalytics(isLoggedIn, userId) {
    const analyticsDetails: AnalyticsDetails = {
        eventName: 'user-page',
        category: 'user-page',
        action: 'visit-page',
        label: 'visit-page',
        visitorType: 'fan',
        visitorLoginState: 'no',
        pageLocale: navigator.languages[0],
    };

    // Check if analytics_storage consent is granted
    const consentSettings = JSON.parse(localStorage.getItem('cookieConsent'));
    if (!consentSettings || consentSettings.analytics_storage !== 'granted') {
        return;
    }

    if (isLoggedIn) {
        const encryptedEmail = await encryptString(userId);
        analyticsDetails.user_id = encryptedEmail;
        analyticsDetails.visitorLoginState = 'yes';
    }

    event(analyticsDetails);
}

export function saveConsentSettngs(consentSettings) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'cookieConsentUpdate',
        cookie_banner_consent: consentSettings,
    });
}


export default {
    event,
};
